"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const lodash_1 = require("lodash");
const selectors_1 = require("@/store/ducks/users/selectors");
const users_1 = require("@/store/ducks/users");
const index_view_1 = __importDefault(require("./index.view"));
function UsersFilter() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [query, setQuery] = react_1.default.useState("");
    const currentUsers = (0, react_redux_1.useSelector)(selectors_1.usersSelector);
    const onFindUser = (query) => {
        const filteredUsers = currentUsers.filter((currentUser) => {
            return currentUser.username
                .toLowerCase()
                .includes((0, lodash_1.deburr)(query.toLowerCase()));
        });
        dispatch((0, users_1.setFilteredUsers)(filteredUsers));
    };
    const onChange = (event) => {
        setQuery(event.target.value);
        onFindUser(event.target.value);
    };
    return react_1.default.createElement(index_view_1.default, { value: query, onChange: onChange });
}
exports.default = UsersFilter;
